/**
 * This array is joined with a comma and used as a CSS selector to match empty nodes that should not be removed.
 */
export const FlareElementEmptyNodeWhitelist: string[] = [
  'a[name]', // Allow empty anchor tags that have a name attribute because they are bookmarks.
  'iframe', // Allow empty iframe tags as they are not void tags but also do not have content.
  'object' // Allow empty object tags as they are used for multimedia.
];
